// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__aQC7h","rotateSpinner":"Loader_rotateSpinner__PBtuL","LoaderWrapper":"Loader_LoaderWrapper__j1+jp"};